// extracted by mini-css-extract-plugin
export default {"wrapper":"BonusesList_wrapper__KiXud"};